import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import { AppLayout } from './components/layout/AppLayout';
import { ChatView } from './components/chat/ChatView';

/**
 * Top-level App component.
 * Authenticator wraps the whole app — unauthenticated users see the login form,
 * authenticated users see the chat interface.
 */
export function App() {
  return (
    <Authenticator
      hideSignUp={true}
      variation="default"
      loginMechanisms={['email']}
      components={{
        Header() {
          return (
            <div style={{ textAlign: 'center', padding: '1.5rem 1rem 0.5rem' }}>
              <svg width="48" height="48" viewBox="0 0 32 32" fill="none" aria-hidden="true">
                <rect width="32" height="32" rx="8" fill="#00AEBD" />
                <path
                  d="M8 10h3l3 8 3-8h2l3 8 3-8h3l-4.5 12h-2.5l-2.5-7-2.5 7h-2.5L8 10z"
                  fill="white"
                />
              </svg>
              <h2 style={{ marginTop: '0.5rem', fontSize: '1.25rem', fontWeight: 600, color: '#008a96' }}>
                Well Living Lab
              </h2>
              <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.25rem' }}>
                AI Assistant — Sign in to continue
              </p>
            </div>
          );
        },
      }}
    >
      <AuthProvider>
        <ChatProvider>
          <AppLayout>
            <ChatView />
          </AppLayout>
        </ChatProvider>
      </AuthProvider>
    </Authenticator>
  );
}
